import { FileQuestion } from 'lucide-react';

interface EmptyStateProps {
    message: string;
    variant?: 'inline' | 'centered';
    className?: string;
}

export function EmptyState({ message, variant = 'centered', className = '' }: EmptyStateProps) {
    if (variant === 'inline') {
        return (
            <p className={`text-sm text-muted-foreground italic ${className}`}>
                {message}
            </p>
        );
    }

    return (
        <div className={`h-full flex items-center justify-center ${className}`}>
            <div className="text-center p-4 space-y-2">
                <FileQuestion className="h-8 w-8 text-muted-foreground mx-auto opacity-50" />
                <p className="text-muted-foreground font-medium">{message}</p>
            </div>
        </div>
    );
}
